
import { JobService, SaleService } from "@/services";
import { SaleSaveToData, SaleSaveToMailDocumentsMode, SaleSaveToPrintDocumentsMode } from "@/utils/documents/sale-save-to-data";
import Vue from "vue";
import AppSaleTypeSelect from "@/components/sales/SaleTypeSelect.vue";
import AppContactSearchWithBrowseById from "@/components/contacts/ContactSearchWithBrowseByID.vue";
import { Job } from "@/models/job";
import { PeppolService } from "@/services/peppol-service";
import { Sale } from "@/models/base";
import { TranslateResult } from "vue-i18n";
import { convertWordToLanguageAwareLowerCase } from "@/utils/strings";

export default Vue.extend({
	data(){
		return {
			data: new SaleSaveToData(),
			isSending: false,
			waitingForFinish: false,
			canSendPeppol: false,
		};
	},
	props: {
		contactGroupId: {
			type: Number,
			required: true
		},
		selectedItems: {
			type: Array as ()=>Sale[],
			default: ()=>[]
		}
	},
	computed: {
		contactGroupName():string{
			return this.$ct("common.contact-group." + this.contactGroupId).toString() + " (" + this.$ct("common.optional").toString() + ")";
		},
		mailModeOn():boolean {
			return this.data.MailDocumentsMode != SaleSaveToMailDocumentsMode.NONE;
		},
		mailModeOnlyIfNoPeppol():boolean {
			return this.data.MailDocumentsMode == SaleSaveToMailDocumentsMode.IF_NO_PEPPOL;
		},
		printModeOn():boolean {
			return this.data.PrintDocumentsMode != SaleSaveToPrintDocumentsMode.NONE;
		},
		printModeOnlyIfNoMail():boolean {
			return this.data.PrintDocumentsMode == SaleSaveToPrintDocumentsMode.IF_NO_MAIL;
		}
	},
	watch: {
		"data.SendViaPeppol"(){
			if (!this.data.SendViaPeppol && SaleSaveToMailDocumentsMode.IF_NO_PEPPOL) {
				this.data.MailDocumentsMode = SaleSaveToMailDocumentsMode.ALL;
			}
		},
		"data.MailDocumentsMode"(){
			if (this.data.MailDocumentsMode == SaleSaveToMailDocumentsMode.NONE && this.data.PrintDocumentsMode == SaleSaveToPrintDocumentsMode.IF_NO_MAIL) {
				this.data.PrintDocumentsMode = SaleSaveToPrintDocumentsMode.ALL;
			}
		}

	},
	methods: {
		close(){
			this.$emit("close");
		},
		createGonnaCreateDocumentText(count:number):TranslateResult{
			let docType = SaleService.getTypeNamePlural(this.data.TargetDocumentTypeID);
			if (count == 1) {
				docType = SaleService.getTypeName(this.data.TargetDocumentTypeID);
			}
			docType = convertWordToLanguageAwareLowerCase(docType);
			let text = this.$ctc("gonna-create-x-documents", count, {docType});
			if (this.data.MailDocumentsMode != SaleSaveToMailDocumentsMode.NONE && this.data.SendViaPeppol) {
				text +=  " " + this.$ctc("gonna-create-x-documents-send-via-peppol-or-email-modifier", count);
			}else if (this.data.MailDocumentsMode != SaleSaveToMailDocumentsMode.NONE) {
				text +=  " " + this.$ctc("gonna-create-x-documents-send-via-mail-modifier", count);
			}else if (this.data.SendViaPeppol) {
				text +=  " " + this.$ctc("gonna-create-x-documents-send-via-peppol-modifier", count);
			}else {
				text += ".";
			}
			text += " " + this.$ct("gonna-create-x-documents-continue");
			return text;
		},
		async confirm(){
			if (this.isSending) return;
			try{
				this.isSending = true;
				this.data.ToUseDocumentIDs = this.selectedItems.map(i=>i.ID);
				let count = await SaleService.saveSaleToCountToCreateDocuments(this.data);
				if (count == 0){
					let text = this.$ct("no-documents-to-create");
					this.$wf.dialog(text, this.$ct("common.Ok"), this.$ct("common.error"), "warning");
					return;
				}
				let text = this.createGonnaCreateDocumentText(count);
				let confirm = await this.$wf.confirm(text, this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "warning");
				if (!confirm) return;
				let job = await SaleService.saveSaleTo(this.data);
				this.data.saveDefaultSettings();
				if (this.data.PrintDocumentsMode == SaleSaveToPrintDocumentsMode.NONE){
					this.close();
					this.selectedItems.splice(0, this.selectedItems.length);
				}else{
					this.waitingForFinish = true;
					JobService.once(`job-stopped/${job.getID()}`, this.printDocumentsFromNotification);
				}
			}catch(err){
			}finally{
				this.isSending = false;
			}
		},
		printDocumentsFromNotification(job:Job){
			if (job.Error || job.StatusMessage != "done") {
				this.close();
			}
			let result:{ToPrintDocuments:number[]} = JSON.parse(job.StatusMessageData[0]);
			let toPrintSaleIds:number[] = (result.ToPrintDocuments || []);
			console.log("Got result from job", result);
			if (toPrintSaleIds.length >0) {
				SaleService.printSalesMultiple(toPrintSaleIds,0);
			}
			this.close();
			this.selectedItems.splice(0, this.selectedItems.length);
		},
		setMailModeOn(value:boolean){
			if (value) {
				this.data.MailDocumentsMode = SaleSaveToMailDocumentsMode.ALL;
			}else{
				this.data.MailDocumentsMode = SaleSaveToMailDocumentsMode.NONE;
			}
		},
		setMailModeOnlyIfNoPeppol(value:boolean){
			if (value){
				this.data.MailDocumentsMode = SaleSaveToMailDocumentsMode.IF_NO_PEPPOL;
			}else{
				this.data.MailDocumentsMode = SaleSaveToMailDocumentsMode.ALL;
			}
		},
		setPrintModeOn(value:boolean) {
			if (value) {
				this.data.PrintDocumentsMode = SaleSaveToPrintDocumentsMode.ALL;
			}else{
				this.data.PrintDocumentsMode = SaleSaveToPrintDocumentsMode.NONE;
			}
		},
		setPrintDocumentModeIfNoMail(value:boolean){
			if (value) {
				this.data.PrintDocumentsMode = SaleSaveToPrintDocumentsMode.IF_NO_MAIL;
			}else{
				this.data.PrintDocumentsMode = SaleSaveToPrintDocumentsMode.ALL;
			}
		}
	},
	async created(){
		this.canSendPeppol = await PeppolService.isPeppolReadyForSending();
	},
	components: {
		AppSaleTypeSelect,
		AppContactSearchWithBrowseById
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
